import keyMirror from 'react-utils/keyMirror';
import { createAction, createRequestTypes, createRequestActions } from './utils';
export const AppUserActionTypes = keyMirror({
  LOAD_APP_USER: null
});
export const FETCH_APP_USER = 'FETCH_APP_USER';
export const FetchAppUserActionTypes = createRequestTypes(FETCH_APP_USER);
export const FetchAppUser = createRequestActions(FetchAppUserActionTypes);
export const loadAppUser = data => createAction(AppUserActionTypes.LOAD_APP_USER, {
  data
});